import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class DummyMaskProcessing extends InputMaskProcessingBase {}
